import React from 'react';
import { useNotifications } from '../context/NotificationContext';
import { X, Trash2, CheckCheck, Bell, BellOff } from 'lucide-react';
import './NotificationCenter.css';

const NotificationCenter = ({ isOpen, onClose }) => {
  const { notifications, markAsRead, clearNotifications, toastsEnabled, toggleToasts } = useNotifications();

  if (!isOpen) return null;

  return (
    <div className="notification-center-dropdown">
      <div className="nc-header">
        <h3>Notificaciones</h3>
        <div className="nc-actions">
          <button 
            onClick={toggleToasts} 
            className={`nc-toggle-btn ${toastsEnabled ? 'active' : 'muted'}`}
            title={toastsEnabled ? "Avisos emergentes flotantes: ACTIVADOS (Clic para desactivar)" : "Avisos emergentes flotantes: DESACTIVADOS (Solo en campana)"}
          >
            {toastsEnabled ? <Bell size={16} /> : <BellOff size={16} />}
            <span className="nc-toggle-label">{toastsEnabled ? 'POP-UPS ON' : 'POP-UPS OFF'}</span>
          </button>
          <button onClick={markAsRead} title="Marcar todo como leído">
            <CheckCheck size={16} />
          </button>
          <button onClick={clearNotifications} title="Limpiar todo">
            <Trash2 size={16} />
          </button>
          <button onClick={onClose} className="nc-close">
            <X size={18} />
          </button>
        </div>
      </div>
      
      <div className="nc-body">
        {notifications.length === 0 ? (
          <div className="nc-empty">No hay notificaciones nuevas</div>
        ) : (
          notifications.map(n => (
            <div key={n.id} className={`nc-item ${n.read ? 'read' : 'unread'} ${n.type}`}>
              <div className="nc-item-content">
                <p className="nc-message">{n.message}</p>
                <span className="nc-time">{n.time}</span>
              </div>
            </div>
          ))
        )}
      </div>
    </div>
  );
};

export default NotificationCenter;
